import { createRouter, createWebHistory } from 'vue-router';
import { store } from '@/store/store';
import MyProfile from '@/components/MyProfile.vue';
import HomePage from '@/views/HomePage.vue';
import TestPage from '@/views/TestPage.vue';
import BookDetails from '@/views/BookDetails.vue';
import LoginPage from '@/views/LoginPage.vue';
import SignupPage from '@/views/SignupPage.vue';
import WishlistPage from '@/views/WishlistPage.vue';
import CartPage from '@/views/CartPage.vue';
import CheckoutPage from '@/views/CheckoutPage.vue';
import OrdersPage from '@/views/OrdersPage.vue';
import SearchPage from '@/views/SearchPage.vue';
// import AuthorSearch from '@/views/AuthorSearch.vue';
import ContactPage from '@/views/ContactPage.vue';
import AboutUs from '@/views/AboutUs.vue';
import CategoryPage from '@/views/CategoryPage.vue';
import PrivacyPolicy from '@/views/PrivacyPolicy.vue';
import TermsConditions from '@/views/TermsConditions.vue';
import ReturnRefundPolicy from '@/views/ReturnRefundPolicy.vue';
import DeliveryPolicy from '@/views/DeliveryPolicy.vue';
import FaqPage from '@/views/FaqPage.vue';

const routes = [
  { path: '/', component: HomePage },
  { path: '/book/:id/:slug?', name: 'ProductDetails', component: BookDetails },
  // { path: '/author', name: 'AuthorDetails', component: AuthorSearch },
  { path: '/login', component: LoginPage },
  { path: '/signup', component: SignupPage },
  { path: '/profile', component: MyProfile, meta: { requiresAuth: true }  },
  { path: '/wishlist', component: WishlistPage  },
  { path: '/cart', component: CartPage  },
  { path: '/checkout', component: CheckoutPage  },
  { path: '/orders', component: OrdersPage  },
  { path: '/search', component: SearchPage  },
  { path: '/category', component: CategoryPage  },
  { path: '/about', component: AboutUs  },
  { path: '/contact', component: ContactPage  },
  { path: '/privacy-policy', component: PrivacyPolicy },
  { path: '/terms', component: TermsConditions },
  { path: '/return-refund-policy', component: ReturnRefundPolicy },
  { path: '/delivery-policy', component: DeliveryPolicy },
  { path: '/faq', component: FaqPage },
  { path: '/test', component: TestPage },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
  linkActiveClass: 'active', // <-- Bootstrap .active class
  linkExactActiveClass: 'active' // optional, for exact match
});

// Navigation Guard for Auth
router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters.isLoggedIn
  if (to.meta.requiresAuth && !isLoggedIn) {
    next('/login');
  } else {
    next();
  }
});

export default router;
